/* Shared by the storefront and the consent-gated Shopify checkout pixel. */
(function(root){
'use strict';
const PREFIX='artesta:gallery:delivery:v2:',MAX_AGE=7*86400000,MAX_QUEUE=200;
function createQueue(options){
 const now=options.now||Date.now,memory=new Map();let busy=false,timer=null,disposed=false;
 const permitted=()=>{try{return options.allowed()===true;}catch{return false;}};
 const key=payload=>PREFIX+payload.event_id;
 function valid(row){return row&&row.payload?.version===2&&typeof row.payload.event_id==='string'&&/^(?:[a-f0-9-]{36}|[a-f0-9]{64})$/.test(row.payload.event_id)&&Number.isFinite(Date.parse(row.payload.occurred_at))&&now()-Date.parse(row.payload.occurred_at)<=MAX_AGE&&Date.parse(row.payload.occurred_at)<=now()+300000;}
 async function remove(entry){memory.delete(entry.payload.event_id);try{await options.storage.remove(key(entry.payload));}catch{}}
 async function restore(){
  if(!permitted())return;
  let entries=[];try{entries=await options.storage.entries(PREFIX);}catch{}
  for(const [name,text] of entries){
   if(!name.startsWith(PREFIX))continue;
   let row;try{row=JSON.parse(text);}catch{}
   if(!valid(row)||name!==key(row.payload)){try{await options.storage.remove(name);}catch{}continue;}
   row.next_at=Number.isFinite(row.next_at)?Math.min(row.next_at,now()+60000):0;
   if(!memory.has(row.payload.event_id)&&memory.size<MAX_QUEUE)memory.set(row.payload.event_id,row);
  }
 }
 function schedule(delay){
  if(disposed||timer!==null)return;
  timer=(options.setTimeout||setTimeout)(()=>{timer=null;void flush();},Math.max(250,delay));
 }
 async function clear(){
  memory.clear();if(timer!==null){(options.clearTimeout||clearTimeout)(timer);timer=null;}
  let rows=[];try{rows=await options.storage.entries(PREFIX);}catch{}
  for(const [name] of rows)if(name.startsWith(PREFIX)){try{await options.storage.remove(name);}catch{}}
 }
 async function flush(){
  if(disposed||busy||!permitted())return;
  busy=true;
  try{
   await restore();
   const rows=[...memory.values()].sort((a,b)=>Date.parse(a.payload.occurred_at)-Date.parse(b.payload.occurred_at));
   for(const row of rows){
    if(!permitted()){await clear();break;}
    if(!valid(row)){await remove(row);continue;}
    if(row.next_at>now())continue;
    try{
     const ack=await options.send(row.payload);
     if(!ack||ack.ok!==true||ack.event_id!==row.payload.event_id)throw Error('Unconfirmed event');
     await remove(row);
    }catch(error){
     if(!permitted()){await clear();break;}
     if(error?.permanent){await remove(row);continue;}
     row.attempts=Math.min(16,(Number(row.attempts)||0)+1);
     row.next_at=now()+Math.min(60000,1000*2**Math.min(row.attempts-1,6));
     let stillStored=true;
     try{stillStored=!row.persisted||Boolean(await options.storage.get(key(row.payload)));}catch{}
     if(!stillStored){memory.delete(row.payload.event_id);continue;}
     try{await options.storage.set(key(row.payload),JSON.stringify(row));row.persisted=true;}catch{}
    }
   }
  }finally{
   busy=false;
   if(memory.size&&permitted())schedule(Math.max(250,Math.min(...[...memory.values()].map(r=>r.next_at||now()))-now()));
  }
 }
 async function add(payload){
  if(disposed||!permitted())return false;
  const row={payload,attempts:0,next_at:0,persisted:false};
  if(!valid(row)||memory.size>=MAX_QUEUE)return false;
  if(memory.has(payload.event_id))return true;
  memory.set(payload.event_id,row);
  try{await options.storage.set(key(payload),JSON.stringify({...row,persisted:true}));row.persisted=true;}catch{}
  if(!permitted()){await clear();return false;}
  void flush();return true;
 }
 return {add,flush,clear,dispose(){disposed=true;if(timer!==null)(options.clearTimeout||clearTimeout)(timer);},pending:()=>memory.size};
}
const api={createQueue,PREFIX,MAX_AGE};
if(typeof module==='object'&&module.exports)module.exports=api;else root.ArtestaGalleryDelivery=api;
})(typeof globalThis==='object'?globalThis:this);
